import React from 'react';
import { List, Icon, notification, Button, Tabs, Modal, DatePicker, message, Empty, Skeleton, Tooltip, Drawer, Popover } from 'antd';
import ActivityService from '../../../services/activity.service';
import { getCurrentUser, getParishCoordinates, dmsToDecimalDegrees, dateToUnix, getStatusIcon, getDayOfWeek, isPhone, modalConfig } from '../../../utils/utils';
import { YEARS, months } from '../../../utils/dates';
import './activity-list.scss';
import Activity from '../activity/activity';
import moment from 'moment';
import FinishActivity from '../finish/fininsh-activity';
import defaultThumbnail from '../../../assets/thumbnail-default.jpg';
import { thumbs } from '../../../utils/static-data';
import ActivityMap from './activity-map';
import blueMarker from '../../../assets/blue-marker.png';
import greenMarker from '../../../assets/green-marker.png';
import redMarker from '../../../assets/red-marker.png';
import { PrintPopOverContent } from './print-popover';

const { TabPane } = Tabs;

export class ActivityList extends React.Component {

  state = {
    listData: [],
    currentActivity: null,
    currentRange: null,
    currentTab: 0,
    currentTime: 0,
    watchActivity: false,
    showPostponeDatePicker: false,
    confirmPostpone: false,
    loadingData: false,
    finishActivityModal: false,
    currentPostponeActivity: {},
    currentfinishActivity: {},
    showMap: false
  };

  currentYear = dateToUnix(YEARS[new Date().getFullYear().toString()]);

  componentDidMount() {
    const currentDate = new Date().getTime();
    const currentTab = this.currentYear.findIndex(range => (range.start <= currentDate && range.end >= currentDate));
    this.setState({ currentTab, currentRange: this.currentYear[currentTab] });
    this.getActivities(this.currentYear[currentTab]);
  }

  printWeek = async () => {
    const { currentRange } = this.state;
    const user = getCurrentUser();

    if (currentRange) {
      try {
        const result = await ActivityService.printActivitiesWithConfig(currentRange.start, currentRange.end, null, [2, 3].includes(user.role) ? null : user.organism);
        const urlBlob = URL.createObjectURL(result);
        window.open(urlBlob, '_blank');
      } catch (error) {
        message.error(error.toString());
      }

    }
  }

  getActivities = async (dateRange) => {
    try {
      this.setState({ loadingData: true });
      const user = getCurrentUser();
      const organism = [1, 4].includes(user.role) ? user.organism : 0;
      const result = await ActivityService.getActivitiesWithConfig(dateRange.start, dateRange.end, null, organism);
      this.setState(
        {
          listData: result.activities.map(activity => ({
            id: activity.id,
            governor_present: activity.governor_present ? 1 : 0,
            href: 'http://ant.design',
            title: activity.title,
            description: `${getParishCoordinates(activity.location).name} - ${activity.orgname}`,
            content: activity.description,
            status: activity.status,
            date: new Date(Number.parseInt(activity.date) * 1000).toLocaleDateString(),
            rawDate: activity.date,
            lat: activity.lat || dmsToDecimalDegrees(getParishCoordinates(activity.location).lat),
            lng: activity.lng || dmsToDecimalDegrees(getParishCoordinates(activity.location).lng) * -1,
            photos: JSON.parse(activity.attachments),
            dayOfWeek: getDayOfWeek(new Date(Number.parseInt(activity.date) * 1000).getDay()),
            final_observation: activity.final_observation,
            thumbnail: activity.thumbnail
          })),
          currentTime: result.currentTime,
          loadingData: false
        });

    } catch (error) {
      notification.error({ message: "Ha ocurrido un error." })
      this.setState({ loadingData: false });
    }

  }

  showActivity = (activity) => {
    const { watchActivity } = this.state;
    if (!watchActivity) {
      this.setState({
        watchActivity: true,
        currentActivity: activity
      });
    } else {
      this.setState({
        watchActivity: false
      });
    }
  }

  handleTabChange = (e) => {
    this.setState({
      listData: [],
      currentTab: e,
      currentRange: this.currentYear[e],
      showPostponeDatePicker: false,
      confirmPostpone: false,
      currentPostponeActivity: {}
    });
    this.getActivities(this.currentYear[e]);
  }

  setGovernorPresent = async (activity) => {

    const { listData } = this.state;
    try {
      const result = await ActivityService.setGovernorPresence(activity.id);
      listData.forEach(act => {
        if (activity.id === act.id) {
          act.governor_present = result.currentStatus;
        }
      });
      this.setState({ listData });
    } catch (error) {
      notification.error({ message: 'Ha ocurrido un error' });
    }

  }

  onPostponeClick = (activity) => {
    this.changePostponeButtonIcon(activity, !this.state.showPostponeDatePicker);
    this.setState(state => (
      {
        showPostponeDatePicker: !state.showPostponeDatePicker,
        currentPostponeActivity: activity
      }
    ));
  }

  dateChanged = date => {
    this.setState({
      dateToPostpone: moment(date).unix()
    })
  }

  setPostpone = () => {
    const messageInfo = message.info('Posponiendo actividad');
    const { currentPostponeActivity, dateToPostpone, listData } = this.state;
    ActivityService.postponeActivity(currentPostponeActivity.id, dateToPostpone)
      .then(res => {
        messageInfo();
        message.success(`Actividad pospuesta para la fecha ${new Date(dateToPostpone * 1000).toLocaleDateString()}`);
        listData.map(act => {
          if (currentPostponeActivity.id === act.id) {
            act.date = new Date(dateToPostpone * 1000).toLocaleDateString();
            act.rawDate = dateToPostpone;
            act.waitingForPostpone = false;
          } else {
            act.disablePostpone = false;
          }
          return act;
        });
        this.setState({ listData, showPostponeDatePicker: false });
      }).catch(err => message.error("Ha ocurrido un error al diferir actividad."));
  }

  changePostponeButtonIcon = (activity, result) => {
    const { listData } = this.state;
    listData.forEach(act => {
      if (activity.id === act.id) {
        act.waitingForPostpone = result;
      } else {
        act.disablePostpone = result;
      }
    });
    this.setState({ listData });
  }

  cancelPostpone = activity => {
    const { listData } = this.state;
    listData.forEach(act => {
      if (activity.id === act.id) {
        act.waitingForPostpone = false;
      } else {
        act.disablePostpone = false;
      }
    });
    this.setState({ listData, showPostponeDatePicker: false, currentPostponeActivity: {} });
  }

  onFinishActivityClick = activity => {
    this.setState({ finishActivityModal: true, currentfinishActivity: activity });
  }

  closeFinishModal = () => {
    this.setState({ finishActivityModal: false, currentFinishActivity: {} });
  }

  handleFinished = (result) => {
    const ld = this.state.listData.map(act => {
      if (act.id === this.state.currentfinishActivity.id) {
        act.final_observation = result.final_observation;
        act.status = result.status;
      }
      return act;
    })
    this.setState({ finishActivityModal: false, currentFinishActivity: {}, listData: ld });
  }

  showMapOrList = () => {
    this.setState(state => ({ showMap: !state.showMap }));
  }

  actions = () => (
    <div className="actions">
      {this.state.showMap && <Tooltip title="A ejecutar">
        <img src={blueMarker} alt="blueMarker" width="25" height="25" />
      </Tooltip>}
      {this.state.showMap && <Tooltip title="Realizada">
        <img src={greenMarker} alt="greenMarker" width="25" height="25" />
      </Tooltip>}
      {this.state.showMap && <Tooltip title="No realizada">
        <img src={redMarker} alt="redMarker" width="25" height="25" />
      </Tooltip>}

      <Tooltip title={this.state.showMap ? "Listado" : "Mapa"}>
        <Button disabled={this.state.listData.length < 1} shape="circle" icon={this.state.showMap ? "unordered-list" : "compass"} type="primary" onClick={this.showMapOrList} />
      </Tooltip>

      <Popover title="Reportes" placement="bottomLeft" content={<PrintPopOverContent printWeek={this.printWeek} printMonth={this.printMonth} />} trigger="click">
        <Button disabled={this.state.listData.length < 1} shape="circle" icon="printer" type="primary" />
      </Popover>

    </div>
  )

  printMonth = async (year, month) => {
    const user = getCurrentUser();
    const currentRange = months[year][month];
    if (currentRange) {
      try {
        const result = await ActivityService.getActivityTableByDateRange(currentRange, [2, 3].includes(user.role) ? null : user.organism);
        const urlBlob = URL.createObjectURL(result);
        window.open(urlBlob, '_blank');
      } catch (error) {
        message.error(error.toString());
      }

    }
  }

  render() {

    const currentDate = new Date().getTime();
    const currentTab = this.currentYear.findIndex(range => (range.start <= currentDate && range.end >= currentDate));

    return (
      <div className="activity-container">
        <div className="button-panel">
          <h2>{this.state.showMap ? 'Mapa' : 'Listado'} de actividades</h2>
          {this.actions()}
        </div>
        <Modal footer={null} width="70vw" visible={this.state.finishActivityModal} onCancel={this.closeFinishModal} >
          <FinishActivity onDone={this.handleFinished} activity={this.state.currentfinishActivity} />
        </Modal>
        <Tabs onChange={this.handleTabChange} defaultActiveKey={currentTab.toString()} tabPosition={isPhone() ? "bottom" : "left"} className="tabs">
          {
            this.currentYear.map((dates, i) =>
              (
                <TabPane tab={<span className="tabText">Semana {i + 1}</span>} key={i} className="tab" >
                  <span className="dateSpan">{new Date(dates.start).toLocaleDateString()} ~ {new Date(dates.end).toLocaleDateString()}</span>
                  {this.state.showMap ?
                    <div className="map">
                      <ActivityMap activities={this.state.listData} />
                    </div>
                    :
                    this.state.loadingData ?
                      <Skeleton active />
                      :
                      this.state.listData.length > 0 ?
                        <div className="activity-list">
                          <DatePicker
                            onChange={this.dateChanged}
                            open={this.state.showPostponeDatePicker}
                            showTime
                            format="DD-MM-Y HH:mm"
                            disabledDate={(currentDate) => currentDate && currentDate < moment().startOf('day')}
                            style={{ visibility: 'hidden', position: 'fixed', bottom: 10, right: 10 }} />
                          <ActivityItems
                            className="activity-list"
                            listData={this.state.listData}
                            onGovernorPresentClick={this.setGovernorPresent}
                            showActivity={this.showActivity}
                            onPostponeClick={this.onPostponeClick}
                            setPostpone={this.setPostpone}
                            cancelPostpone={this.cancelPostpone}
                            currentTime={this.state.currentTime}
                            onFinishActivityClick={this.onFinishActivityClick}
                          />
                        </div> :
                        <Empty description="No hay actividades para esta semana" />
                  }
                </TabPane>
              )
            )
          }
        </Tabs>

        {isPhone() ?
          (<Drawer width="100vw" title={""} visible={this.state.watchActivity} onClose={this.showActivity}>
            {this.state.currentActivity && <Activity activity={this.state.currentActivity} />}
          </Drawer>)
          : (<Modal
            destroyOnClose={true}
            visible={this.state.watchActivity}
            onCancel={this.showActivity}
            maskClosable={true}
            bodyStyle={{ minHeight: '500px' }}
            width={isPhone() ? "100vw" : "70vw"}
            style={modalConfig()}
            footer={null}>
            <Activity activity={this.state.currentActivity} />
          </Modal>)}

      </div>
    );
  }

}

const printActivity = async (activity) => {
  try {
    message.loading('Generando PDF...');
    const pdf = await ActivityService.getPdf(activity.id)
    const urlBlob = URL.createObjectURL(pdf.data);
    window.open(urlBlob, '_blank');
  } catch (error) {
    message.error(error.toString());
  }

}


const ActivityItems = ({
  listData,
  onGovernorPresentClick,
  showActivity,
  onPostponeClick,
  setPostpone,
  cancelPostpone,
  onFinishActivityClick,
  currentTime }) => {

  const IconText = ({ type, text }) => (
    <span>
      <Icon type={type} style={{ marginRight: 8 }} />
      {text}
    </span>
  );

  return (
    <List
      itemLayout="vertical"
      size={isPhone() ? "small" : "large"}
      split={true}
      pagination={
        !isPhone() ? {
          onChange: page => {
            console.log(page);
          },
          pageSize: 3,
          position: "top"
        } : null}
      dataSource={listData}

      renderItem={item => (
        <List.Item
          key={item.id}
          actions={[
            getStatusIcon(item.status),
            <Button onClick={() => showActivity(item)}>
              <IconText type="eye" text="Ver" />
            </Button>,
            (item.status === 1 && getCurrentUser().role !== 3) &&
            <Button.Group>
              <Button
                disabled={item.disablePostpone}
                onClick={item.waitingForPostpone ? setPostpone : () => onPostponeClick(item)}
                type={item.waitingForPostpone ? "primary" : "default"}>
                <IconText type={item.waitingForPostpone ? "check" : "clock-circle"} text="Posponer" />
              </Button>
              {(item.waitingForPostpone) && <Button
                onClick={() => cancelPostpone(item)}
                type="danger">
                <IconText type="close" text="" />
              </Button>}
            </Button.Group>,
            (item.rawDate > currentTime) ?
              <Button onClick={() => onGovernorPresentClick(item)} type={item.governor_present === 1 ? "primary" : "default"}>
                <IconText type={item.governor_present === 1 ? 'check' : 'uncheck'} text="Presencia del gobernador" />
              </Button>
              :
              (item.status === 1 && getCurrentUser().role !== 3) &&
              <Button onClick={() => onFinishActivityClick(item)} type={item.status === 1 ? "primary" : "default"}>
                <IconText type="check" text="Finalizar actividad" />
              </Button>,
            <Button icon="printer" type="primary" onClick={() => printActivity(item)}></Button>
          ]}
          extra={
            <img
              width={isPhone() ? window.innerWidth : 200}
              height={isPhone() ? 300 : 150}
              className="image-thumb"
              alt="thumbnail"
              src={item.thumbnail ? (thumbs + item.thumbnail) : defaultThumbnail}
            />
          }
        >
          <List.Item.Meta
            title={item.title}
            description={`${item.description} - ${item.dayOfWeek}, ${item.date}`}
          />
          {item.final_observation}
        </List.Item>
      )}
    />
  );
}

export default ActivityList;
